import download from '../utils/download'
export default {
  install(Vue) {
    // 下载文件
    Vue.prototype.$download = download
  }

}



// WEBPACK FOOTER //
// ./src/plugins/index.js